import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials sends the httpOnly `kobolog_token` cookie on every request.
// The cookie is the new default (Iter25) — set on every successful sign-in.
const api = axios.create({ baseURL: API, withCredentials: true });

// Legacy compatibility: users who signed in BEFORE the cookie migration still
// have a JWT in localStorage. We keep sending it as `Authorization: Bearer`
// until the next sign-in refreshes the cookie, then we drop the localStorage
// entry. Never write a new token to localStorage from now on.
api.interceptors.request.use((cfg) => {
  const legacyToken = localStorage.getItem("kudi_token");
  if (legacyToken) cfg.headers.Authorization = `Bearer ${legacyToken}`;
  return cfg;
});

// If our token is expired/invalid, wipe the legacy localStorage token so we
// re-prompt OTP cleanly. Cookie is cleared by the backend on 401 flows.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/")) {
      localStorage.removeItem("kudi_token");
      if (window.location.pathname.startsWith("/app")) {
        window.location.assign("/signin");
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const fmtNaira = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "₦0";
  const num = Number(n);
  return "₦" + num.toLocaleString("en-NG", { maximumFractionDigits: 0 });
};

export const fmtNairaPrecise = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "₦0.00";
  return "₦" + Number(n).toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-NG", { day: "numeric", month: "short" });
};

export const fmtTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleTimeString("en-NG", { hour: "2-digit", minute: "2-digit" });
};
